import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule, MatIconModule } from '@angular/material';
import { TranslateModule } from '@ngx-translate/core';

import { IndicationPopUpComponent } from './indication-pop-up.component';

@NgModule({
  entryComponents: [
    IndicationPopUpComponent,
  ],
  imports: [
    CommonModule,
    OverlayModule,
    MatIconModule,
    MatButtonModule,
    TranslateModule
  ],
  declarations: [
    IndicationPopUpComponent,
  ],
  exports: [
    IndicationPopUpComponent
  ]
})
export class IndicationPopUpModule {}
